import { he } from "date-fns/locale";
import type { SVGProps } from "react";

const ElectricityIcon = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M4.167 10.078c0-4.415 3.497-7.994 7.812-7.994s7.813 3.579 7.813 7.994a8.058 8.058 0 0 1-2.603 5.957c-.532.488-.926.849-1.206 1.11a15.124 15.124 0 0 0-.417.407 1.08 1.08 0 0 0-.034.038c-.246.311-.3.392-.331.464-.032.073-.055.167-.117.563-.025.156-.027.423-.027 1.15v.032c0 .426 0 .794-.027 1.095-.028.32-.09.635-.259.933a2.154 2.154 0 0 1-.78.798c-.29.172-.6.236-.91.265-.296.027-.655.027-1.071.027h-.061c-.417 0-.776 0-1.07-.027-.313-.03-.621-.093-.912-.265a2.155 2.155 0 0 1-.78-.798c-.168-.298-.23-.614-.259-.933-.027-.301-.027-.669-.027-1.095v-.031c0-.728-.002-.995-.027-1.152-.062-.395-.085-.489-.116-.562-.032-.072-.085-.153-.332-.464l-.009-.01a15.245 15.245 0 0 0-.442-.434c-.28-.262-.674-.623-1.206-1.111a8.059 8.059 0 0 1-2.602-5.957Z"
    />
    <path
      fill="#FBFBFB"
      d="m9.32 10.022 1.359-1.864c.878-1.205 1.317-1.808 1.727-1.68.41.127.41.866.41 2.344v.14c0 .532 0 .799.167.966l.01.009c.171.163.445.163.992.163.984 0 1.476 0 1.643.303l.008.015c.157.308-.128.699-.698 1.48l-1.359 1.865c-.878 1.205-1.317 1.808-1.727 1.68-.41-.127-.41-.866-.41-2.344v-.14c0-.532 0-.799-.168-.966l-.008-.009c-.172-.163-.446-.163-.993-.163-.984 0-1.477 0-1.643-.303a.436.436 0 0 1-.008-.015c-.157-.308.128-.699.698-1.481ZM13.63 20.495h-3.302c.003.1.008.189.015.268.019.218.052.298.074.337.062.11.152.202.26.266.038.023.116.056.33.076.222.021.516.022.972.022.456 0 .75-.001.973-.022.213-.02.29-.053.329-.076a.72.72 0 0 0 .26-.266c.022-.04.055-.119.074-.337.007-.08.012-.167.015-.268Z"
    />
  </svg>
);
export default ElectricityIcon;
